import { Modal } from 'components/Modal';
import { Restricted } from 'components/Restricted';
import { EndFocus } from 'components/buttons/EndFocus';
import { SkipContentButton } from 'components/buttons/SkipContentButton';
import { PrimaryButton, SecondaryButton } from 'components/buttons/v4';
import { ContentTable } from 'components/content/ContentTable';
import { CreateModal } from 'components/modals/create-flow/CreateModal';
import { ContentSection, PageContainer, PageTitle, TitleSection } from 'core/layout';
import { useDocumentTitle } from 'hooks/useDocumentTitle';
import { MutableRefObject, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { AnalyticsService } from 'utils/AnalyticsService';
import { CONTENT_CREATOR_ROLES } from 'utils/constants';

export const ContentPage = () => {
  const { t } = useTranslation();
  const endFocusRef: MutableRefObject<HTMLDivElement | null> = useRef(null);
  const [showCreateModal, setShowCreateModal] = useState<boolean>(false);
  const [contentTableResetSort, setContentTableResetSort] = useState<(() => void) | null>(null);

  useEffect(() => {
    AnalyticsService.getInstance().track('all_content_page_viewed');
  }, []);

  const handleCreateClick = () => {
    AnalyticsService.getInstance().track('create_button_clicked');
    setShowCreateModal(true);
  };

  const handleCreateModalClose = () => {
    setShowCreateModal(false);
  };

  const handleSetCreated = () => {
    if (contentTableResetSort) {
      contentTableResetSort();
    }
  };

  useDocumentTitle(t('All Content'));

  return (
    <MainFrame>
      <PageContainer>
        <TitleSection>
          <div style={{ display: 'flex', flexDirection: 'row' }}>
            <PageTitle>{t('All Content')}</PageTitle>
            <SkipContentButton endFocusRef={endFocusRef} />
          </div>
          <ButtonsContainer>
            <Restricted
              allowedRoles={[]}
              component={
                <Link to="/nav/content/intelligence" style={{ textDecoration: 'none' }}>
                  <SecondaryButton click={() => {}}>{t('Content Intelligence')}</SecondaryButton>
                </Link>
              }
            />
            <Restricted
              allowedRoles={CONTENT_CREATOR_ROLES}
              component={<PrimaryButton click={handleCreateClick}>{t('+ Create')}</PrimaryButton>}
            />
          </ButtonsContainer>
        </TitleSection>
        <ContentSection style={{ paddingBottom: '48px' }}>
          <ContentTable registerSortReset={setContentTableResetSort} />
          <EndFocus endFocusRef={endFocusRef} />
        </ContentSection>
      </PageContainer>

      {showCreateModal && <CreateModal onClose={handleCreateModalClose} onSetCreated={handleSetCreated} />}
    </MainFrame>
  );
};

const MainFrame = styled.div`
  height: 100vh;
  display: flex;
  flex-grow: 1;
  border: none;
`;

const ButtonsContainer = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
`;
